// extracted by mini-css-extract-plugin
module.exports = {"root":"Text_root__oKLoP","normal":"Text_normal__zb_d8","bold":"Text_bold__iKc6v","noMargin":"Text_noMargin__JucpC","responsive":"Text_responsive__2Dzn3"};